export enum ButtonType {
	ICON = 'icon',
	TEXT = 'text'
}